import { HD, FULL_HD, safetyMargins } from '@bedrock-rdk/constants';
import { PRIMARY, makeThemeColor } from '@tornado-rdk/theme';
import { FONT, getFont } from '@tornado-rdk/typography';
import { SCREEN_WIDTH } from '../../utils/sizes';
import { makeDefaultStylingContext } from '../../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const LOGO_DIMENSIONS = {
  [HD]: {
    width: SCREEN_WIDTH[HD] - safetyMargins.horizontal[HD] * 2,
    height: 150,
  },
  [FULL_HD]: {
    width: SCREEN_WIDTH[FULL_HD] - safetyMargins.horizontal[FULL_HD] * 2,
    height: 214,
  },
};

export const TEXT_WIDTH = {
  [HD]: SCREEN_WIDTH[HD] - safetyMargins.horizontal[HD] * 2,
  [FULL_HD]: SCREEN_WIDTH[FULL_HD] - safetyMargins.horizontal[FULL_HD] * 2,
};

export const GAP = {
  [HD]: 40,
  [FULL_HD]: 40,
};

export const colors = {
  text: makeThemeColor(PRIMARY),
};

export const getTitleFont = screenSize => getFont(FONT.PARIS_3, screenSize);

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  return {
    Logo: {
      flexItem: {
        marginBottom: GAP[screenSize],
      },
    },
    Title: {
      color: colors.text[colorMode],
      text: {
        ...getTitleFont(screenSize),
        maxLinesSuffix: '...',
        wordWrapWidth: TEXT_WIDTH[screenSize],
        maxLines: 2,
      },
    },
    flex: {
      direction: 'column',
    },
  };
};
